
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Component } from '@angular/core';
import { LoadingController, NavParams, Platform } from 'ionic-angular';
import { UserProvider } from '../../../../../../providers/user/user';
import { SharingProvider } from '../../../../../../providers/sharing/sharing';
import { Instagram } from '@ionic-native/instagram';
import { TransferObject, Transfer } from '@ionic-native/transfer';
import { Base64ToGallery, Base64ToGalleryOptions } from '@ionic-native/base64-to-gallery';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Observer } from 'rxjs';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { ResultListModel } from '../../../../../../providers/result/result';
import { resolve } from 'url';
import { SocialSharing } from '@ionic-native/social-sharing';

declare var cordova;

@Component({
    selector: 'page-selfie',
    templateUrl: 'take-selfie.html'
})
export class TakeSelfiePage {
    // 
    result: ResultListModel;
    // 
    imageWidth: number = innerWidth * 0.9;
    imageHeight: number = innerHeight * 0.65;
    // 93px is the margin-top + margin-bottom 
    // imageWidth = (document.getElementsByClassName('scroll-content')[0] as HTMLElement | null).offsetWidth;
    // imageHeight = (document.getElementsByClassName('scroll-content')[0] as HTMLElement | null).offsetHeight - 93;

    imageUrl = "assets/imgs/goforest/forest.jpg";
    preparedImage;
    resultDetails: PictureElements = null;
    canvasStats;

    constructor(
        private camera: Camera,
        private navParams: NavParams,
        private instagram: Instagram,
        private sharingService: SharingProvider,
        private loadingCtrl: LoadingController,
        private userService: UserProvider,
        private translateService: TranslateService,
        private platform: Platform,
        private photoLibrary: PhotoLibrary,
        private base64ToGallery: Base64ToGallery,
        private transfer: Transfer,
        private sharer: SocialSharing,) {
    }

    async ionViewDidLoad() {
        this.resultDetails = await this.navParams.get('resultDetails');
        this.onTakeSelfie();
    }

    onTakeSelfie() {
        const options: CameraOptions = {
            quality: 80,
            destinationType: this.camera.DestinationType.DATA_URL,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            cameraDirection: this.camera.Direction.FRONT,
            correctOrientation: true
        }

        this.camera.getPicture(options)
            .then(
                imageData => {
                    this.imageUrl = 'data:image/jpeg;base64,' + imageData;

                    let canvas = <HTMLCanvasElement>document.getElementById("myCanvas");
                    let context = canvas.getContext("2d");

                    let img = new Image();
                    img.src = this.imageUrl;
                    
                    // img.width = innerWidth;
                    // img.height = innerHeight - 93;
                    // let imageWidth = innerWidth;
                    // let imageHeight = innerHeight;

                    // canvas.width = imageWidth;
                    // alert(this.imageWidth);
                    // canvas.height = imageHeight - 93;
                    // alert(this.imageHeight);

                    let that = this;

                    img.onload = function (e) {
                        canvas.height = img.height;
                        canvas.width = img.width;
                        context.drawImage(img, 0, 0, img.width, img.height);
                        that.canvasStats = <HTMLCanvasElement>document.getElementById("myCanvas");
                        let contextStats = that.canvasStats.getContext("2d");
                        let logo = new Image();
                        logo.src = "assets/imgs/goforest/white.png";
                        console.log('g-3');
                        logo.onload = function () {
                            // that.sharingService.generateImage(that.resultDetails, {context, contextStats},
                            //     that, img, that.canvasStats, logo).then((image) => {
                            //         setTimeout(() => {
                            //             that.preparedImage = that.canvasStats.toDataURL("image/jpeg", 1.0);
                            //         }, 1000);
                            //     })
                            contextStats.font = "200 100px Verdana";
                            contextStats.fillStyle = "white";

                            let distanceHeader = that.translateService.instant("RESULT_CREATE_LABEL_DISTANCE").toUpperCase();
                            let timeHeader = that.translateService.instant("RESULT_CREATE_LABEL_TIME").toUpperCase();
                            let placeHeader = that.translateService.instant("RESULT_CREATE_LABEL_PLATZIRUNG").toUpperCase();

                            let distanceHeaderWidth = contextStats.measureText(distanceHeader).width;
                            let timeHeaderWidth = contextStats.measureText(timeHeader).width;
                            let placeHeaderWidth = contextStats.measureText(placeHeader).width;

                            let leftTopX_level1 = 150;
                            let leftTopY_level1 = 220;

                            let leftTopX_level2 = 150;
                            let leftTopY_level2 = 245;

                            let rightBottomY_level1 = img.height - img.height * 0.26;
                            let rightBottomX_level1_header = (img.width - img.width * 0.03) - distanceHeaderWidth - 50;

                            let rightBottomY_level2 = img.height - img.height * 0.17;
                            let rightBottomX_level2_header = (img.width - img.width * 0.03) - timeHeaderWidth - 50;

                            let rightBottomY_level3 = img.height - img.height * 0.08;
                            let rightBottomX_level3_header = (img.width - img.width * 0.03) - placeHeaderWidth - 50;

                            let leftBottomX = img.width - img.width * 0.98;
                            let leftBottomY = img.height - img.height * 0.13;

                            contextStats.drawImage(logo, leftBottomX, leftBottomY - 220, 575, 575);

                            contextStats.fillText(that.resultDetails.eventName.toUpperCase(), leftTopX_level1, leftTopY_level1);
                            contextStats.fillText(distanceHeader, rightBottomX_level1_header, rightBottomY_level1);
                            contextStats.fillText(timeHeader, rightBottomX_level2_header, rightBottomY_level2);
                            if (that.resultDetails.place.length > 0)
                                contextStats.fillText(placeHeader, rightBottomX_level3_header, rightBottomY_level3);


                                context.font = "600 140px Verdana";
                                contextStats.fillStyle = "white";
    
                                let distanceWidth = context.measureText(that.resultDetails.distance).width;
                                let timeWidth = context.measureText(that.resultDetails.time).width;
                                let placeWidth = context.measureText(that.resultDetails.place).width;
    
                                let rightBottomX_level1 = (img.width - img.width * 0.03) - distanceWidth - 50;
                                let rightBottomX_level2 = (img.width - img.width * 0.03) - timeWidth - 50;
                                let rightBottomX_level3 = (img.width - img.width * 0.03) - placeWidth - 50;
    
                                context.fillText(that.resultDetails.eventDate.split("-").join(".") + " " + that.resultDetails.cid || "", leftTopX_level2, leftTopY_level2 + 100);
                                context.fillText(that.resultDetails.distance, rightBottomX_level1, rightBottomY_level1 + 150);
                                context.fillText(that.resultDetails.time, rightBottomX_level2, rightBottomY_level2 + 150);
                                if (that.resultDetails.place.length > 0)
                                    context.fillText(that.resultDetails.place, rightBottomX_level3, rightBottomY_level3 + 150);
    
                                setTimeout(() => {
                                    that.preparedImage = that.canvasStats.toDataURL("image/jpeg", 1.0);
                                }, 1000);
    
                        }
                        context.fillStyle = 'rgba(0, 0, 0, 0.5)'; 
                        context.fillRect(0, 0, img.width, img.height);
                        context.restore();
                    }
                })
            .catch(
                error => {
                    console.log(error);
                }
            );
    }

    change() {

    }

    addNewPicture(data) {
        console.log(data);
        let loader = this.loadingCtrl.create({
        });
        loader.present();
        console.log('data: ' + data);
        this.userService.createPhoto(-1, data, false).then(data => {
            console.log('the pic is saved successfully!');
            loader.dismiss();
        }).catch(err => {
            console.error('The error while saving the pic!');
        })
    }

    shareFb() {
        this.sharingService.shareFacebook('', this.preparedImage);
    }

    imageLink;
    shareInst(imageData = null) {
        var loader = this.loadingCtrl.create();
        loader.present();
        if(this.platform.is('android')){
            this.photoLibrary.saveImage(this.preparedImage, 'Instagram').then(entry => {
                console.log('s5');
                console.log('this.preparedImage', this.preparedImage)
                this.instagram.isInstalled().then(isInstalled => {
                    if (!isInstalled) {
                      alert("Instagram is not installed on your phone!");
                      loader.dismiss();
                      return;
                    }
                    this.sharer.shareViaInstagram("", this.preparedImage).then(() => {
                      console.log('The image is shared via Instagram!');
                      loader.dismiss();
                    }).catch(err => {
                        loader.dismiss();
                        console.log(err);
                        console.log('The image was not shared via Instagram!');
                    });
                });
            })
        }else{
            this.sharer.shareViaInstagram("", this.preparedImage).then(() => {
                console.log('The image is shared via Instagram!');
                loader.dismiss();
            }).catch(err => {
                loader.dismiss();
                console.log(err);
                console.log('The image was not shared via Instagram!');
            });
        }
    }

    convertToImage(image) {
        let config: Base64ToGalleryOptions = {
            prefix: 'img_',
            mediaScanner: true
        };

        this.base64ToGallery.base64ToGallery(image, config).then(
            res => {
                this.downloadFile(image);
            },
            err => console.log('Error saving image to gallery ', err)
        );
    }

    downloadFile(imageLink) {
        let that = this;
        this.platform.ready().then(() => {

            const fileTransfer: TransferObject = this.transfer.create();

            let storageDirectory = "";

            const imageLocation = this.imageLink;

            if (this.platform.is('ios')) {
                storageDirectory = cordova.file.documentsDirectory;
            }
            else if (this.platform.is('android')) {
                storageDirectory = cordova.file.dataDirectory;
            }

            let image = imageLocation + ".jpeg";

            console.log('storageDirectory: ', storageDirectory);
            fileTransfer.download(imageLocation, storageDirectory + image).then((entry) => {
                console.log('entry: ', entry.toURL());
                this.instagram.shareAsset(entry.toURL()).then(() => {
                    console.log('succes INSTAGRAM');
                });
            }, (error) => {
                console.log(error);
            });

        });
    }

    getBase64ImageFromURL(url: string) {
        return Observable.create((observer: Observer<string>) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = url;
            if (!img.complete) {
                img.onload = () => {
                    observer.next(this.getBase64Image(img));
                    observer.complete();
                };
                img.onerror = (err) => {
                    observer.error(err);
                };
            } else {
                observer.next(this.getBase64Image(img));
                observer.complete();
            }
        });
    }

    getBase64Image(img: HTMLImageElement) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    }

}
export interface PictureElements {
    distance: string;
    time: string;
    place: string;
    eventDate: string;
    logo: string;
    cid: string;
    eventName: string;
}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-results/mysport-results-menu/take-selfie/take-selfie.ts